<!-- 
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
-->


<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="date"
        prepend-icon="mdi-calendar"
        readonly
        :hint="$attrs.hint"
        persistent-hint
        v-bind="attrs"
        v-on="on"
        style="padding-top:22px"
      >
        <template
          v-slot:append
          v-if="date.length > 0"
        >
          <v-icon @click="clearInput">
            mdi-close-circle
          </v-icon>
        </template>
      </v-text-field>
    </template>
    <v-date-picker
      range
      v-model="date"
      @input="menu = date.length == 2 ? false : true"
      v-bind="$attrs"
      v-on="listners"
      :first-day-of-week="1"
      :locale="getLang()"
    >
    </v-date-picker>
  </v-menu>
</template>

<script>
export default {
  inheritsAttrs: false,
  data: () => ({
    date: [],
    menu: false,
  }),
  props: ["value"],
  computed: {
    listners() {
      return {
        ...this.$listners,
        input: event =>
          this.$emit('input', event)
      }
    }
  },
  methods: {
    clearInput() {
      this.date = [];
      this.$emit('input', this.date);
    },
    getLang() {
      switch (this.language.locale) {
        case "en":
          return "en-gb";
        case "nl":
          return "nl-nl";
        default:
          return "en-gb";
      }
    }
  }
};
</script>
